module.exports = __webpack_public_path__ + "img/osmosis.0a4cdf75.svg";